import axios from 'axios'
import { getToken, setToken } from '@/helpers'

const PROFILE = axios.create({
  baseURL: process.env.VUE_APP_PROFILE_URL,
  withCredentials: false,
  headers: {
    Accept: 'application/json; version=2.0.0',
    common: {
      'Content-Type': 'application/json; charset=utf-8',
    },
    post: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  },
  emulateJSON: true,
})

PROFILE.interceptors.request.use(async config => {
  const accessToken = await getToken()
  if (accessToken) config.headers.Authorization = `Bearer ${accessToken}`
  return Promise.resolve(config)
})

PROFILE.interceptors.response.use(async response => {
  if (
    response.data.data.tokens &&
    response.data.data.tokens.data &&
    response.data.data.tokens.data.Bearer
  ) {
    const { Bearer: accessToken } = response.data.data.tokens.data
    await setToken(accessToken)
  }
  if (
    response.data.meta &&
    response.data.meta.tokens &&
    response.data.meta.tokens.Bearer
  ) {
    const { Bearer: accessToken } = response.data.meta.tokens
    await setToken(accessToken)
  }
  return response
})

export default PROFILE
